import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import DispensingSearchBar from '../dispensingSearchBar/DispensingSearchBar';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import SelectedTable from 'utils/table/SelectedTable';
import { Styles } from 'utils/table/Table.css.js';

import { columnSetter }from './columns';
import { makeDataLevel } from './makeDataLevel';
import { customAxiosGetFunction, customAxiosPostFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';

const DispensingDetailTable = (props) => {
  const history = useHistory();
  const dispatchs = useDispatch();
  const user = useSelector(store => store.loginManager.status);
  const [ returnModuleList, setReturnModuleList ] = useState([]);
  const [ selectedModule, setSelectedModule ] = useState('0');
  const [ data, setData ] = useState([]);
  const [ columns, setColumns ] = useState(columnSetter());
  const [ paramState, dispatch ] = useReducer(paramSetterReducer, 
                                              {
                                                pageIndex: 0,
                                                pageCount: 0,
                                                pageSize: 15,
                                                elementCount: 0,
                                                canNextPage: false,
                                                canPreviousPage: false
                                              })

  const setTableData = useCallback(async () => {
    customAxiosGetFunction(history, '/api/dispensing/getData', 
                       {params: {...paramState, moduleIdx: selectedModule, authIdx: user.authIdx, authLevel: user.authLevel, status: 0}}).then(response => {
      if(nvl(response, null) === null) {
        return false;
      }

      dispatch({type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements});
      dispatch({type: 'CHANGE_CANPAGE', canNextPage: !response.last, canPreviousPage: !response.first});
      setData(
        nvl(response.content, []).map((d, index) => {
          return {
            ...makeDataLevel(
              d, 
              paramState.pageIndex, 
              paramState.pageSize, 
              index
            ) 
          }
        })
      );
    })
  }, [paramState, selectedModule])
  
  const returnTheModule = useCallback(async (returnList) => {
    customAxiosPostFunction(history, '/api/dispensing/return', {returnList})
      .then(response => {
        if (response !== null) {
          dispatchs(dispensingModuleManager(Number(user.authIdx)));
          dispatchs(moduleManager(Number(user.authIdx)));
          alert(`반납완료`);
          setTableData();
        }
        else {
          alert(`반납실패`);
        }
      })
      .catch(function (error) {
        alert(`반납실패`);
        console.log(error);
      });
  }, [])

  useEffect(() => {
    setTableData();
    setColumns(columnSetter(setTableData, returnTheModule, props.areas, props.modules));
  }, [paramState.pageIndex, selectedModule])

  return (
    <>
      <DispensingSearchBar areas={props.areas} 
                           modules={props.modules}
                           setTableData={setTableData} 
                           setSelectedModule={setSelectedModule}
                           returnModuleList={returnModuleList}
                           returnTheModule={returnTheModule} />
      <Styles>
        <SelectedTable 
          columns={columns} 
          data={data} 
          setParamDispatch={dispatch}
          setReturnModuleList={setReturnModuleList}
          {...paramState}
        />
      </Styles>
    </>
  )
}

export default DispensingDetailTable;